module.exports = __webpack_public_path__ + "assets/img/gar8-2.ee0ef052.jpg";